import { AutoAwesomeRoundedSVG } from '@modules/common/components/AutoAwesomeRoundedSVG';
import { useIsChatWithFeedbackEnabled } from '@modules/feed/hooks';
import { WisdomLogoIcon } from '@modules/oracle/components/WisdomLogoIcon';
import { LoadingButton } from '@mui/lab';

interface GenerateSummaryButtonProps {
  isLoading: boolean;
  onClick: () => void;
}

export const GenerateSummaryButton = ({
  isLoading,
  onClick,
}: GenerateSummaryButtonProps) => {
  const isChatWithFeedbackEnabled = useIsChatWithFeedbackEnabled();

  return (
    <LoadingButton
      variant="outlined"
      startIcon={
        isChatWithFeedbackEnabled ? (
          <WisdomLogoIcon />
        ) : (
          <AutoAwesomeRoundedSVG />
        )
      }
      loading={isLoading}
      loadingPosition="start"
      onClick={() => onClick()}
      sx={{
        textTransform: 'none',
        border: (theme) =>
          `1px solid ${theme.palette.misc?.wisdom.summary.borderColor}`,
        '&:hover': {
          border: (theme) =>
            `1px solid ${theme.palette.misc?.wisdom.summary.borderColor}`,
        },
      }}
    >
      {isChatWithFeedbackEnabled
        ? 'Ask / Summarize Feed'
        : 'Summarize with Wisdom'}
    </LoadingButton>
  );
};
